module.exports = __webpack_public_path__ + "static/process-4535e082eac0b602aa124a59d4e1ce42.svg";